import React from "react";
import Table from "../../../../components/TableV2";
import TitleButtons from "../../../../components/TitleButtons";
import { useConsumosSuprimentos } from "./consumosData";

const SuprimentosConsumos: React.FC = () => {
  const headers = [
    "Técnico", // 👈 agora é a 1ª coluna
    "Tipo", // 👈 agora é a 2ª coluna
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Custo Unitário",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useConsumosSuprimentos();

  const columnWidths = [
    "150px", // Técnico
    "80px", // Tipo
    "70px", // Código
    "300px", // Nome
    "60px", // Quantidade
    "90px", // Custo
    "90px", // Data
    "60px", // Hora
  ];

  return (
    <div>
      <TitleButtons
        fullBleedLine
        title="Departamento Pessoal - Consumos"
        /*  buttons={[
          {
            label: "Gerar Relatório",
            onClick: () => console.log("Relatório gerado"),
            variant: "secondary",
          },
        ]}*/
      />
      <Table headers={headers} rows={rows} columnWidths={columnWidths} />
    </div>
  );
};

export default SuprimentosConsumos;
